// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThankMessage_wrapper__SVUzy","appear":"ThankMessage_appear__2zdx8","message":"ThankMessage_message__2qRPL","icon":"ThankMessage_icon__1rXI6"};